import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-stripe-success',
  templateUrl: './stripe-success.component.html',
  styleUrls: ['./stripe-success.component.scss']
})
export class StripeSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
